import apiClient from "@/services/api-client";

export const platformControlService = {
  approvals: async (status?: string) =>
    (
      await apiClient.get("/governance-control/approvals", {
        params: { status },
      })
    ).data,
  createApproval: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/governance-control/approvals", payload)).data,
  decideApproval: async (
    id: string,
    decision: "APPROVE" | "REJECT",
    note: string,
  ) =>
    (
      await apiClient.post(`/governance-control/approvals/${id}/decision`, {
        decision,
        note,
      })
    ).data,
  scopeGrants: async () =>
    (await apiClient.get("/governance-control/scope-grants")).data,
  createScopeGrant: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/governance-control/scope-grants", payload)).data,
  revokeScopeGrant: async (id: string, reason: string) =>
    (
      await apiClient.post(`/governance-control/scope-grants/${id}/revoke`, {
        reason,
      })
    ).data,
  invitations: async () =>
    (await apiClient.get("/governance-control/invitations")).data,
  createInvitation: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/governance-control/invitations", payload)).data,
  revokeInvitation: async (id: string, reason: string) =>
    (
      await apiClient.post(`/governance-control/invitations/${id}/revoke`, {
        reason,
      })
    ).data,
  sessions: async () =>
    (await apiClient.get("/governance-control/sessions")).data,
  revokeSession: async (id: string, reason: string) =>
    (
      await apiClient.post(`/governance-control/sessions/${id}/revoke`, {
        reason,
      })
    ).data,
  rbacChangeSets: async () =>
    (await apiClient.get("/governance-control/rbac-change-sets")).data,
  createRbacChangeSet: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/governance-control/rbac-change-sets", payload))
      .data,
  submitRbacChangeSet: async (id: string, reason: string) =>
    (
      await apiClient.post(
        `/governance-control/rbac-change-sets/${id}/submit`,
        { reason },
      )
    ).data,
  reviewRbacChangeSet: async (
    id: string,
    decision: "APPROVE" | "REJECT",
    note: string,
  ) =>
    (
      await apiClient.post(
        `/governance-control/rbac-change-sets/${id}/review`,
        {
          decision,
          note,
        },
      )
    ).data,
  applyRbacChangeSet: async (id: string, reason: string) =>
    (
      await apiClient.post(`/governance-control/rbac-change-sets/${id}/apply`, {
        reason,
      })
    ).data,
  rollbackRbacChangeSet: async (id: string, reason: string) =>
    (
      await apiClient.post(
        `/governance-control/rbac-change-sets/${id}/rollback`,
        { reason },
      )
    ).data,
  ssoProviders: async () =>
    (await apiClient.get("/governance-control/sso-providers")).data,
  createSsoProvider: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/governance-control/sso-providers", payload)).data,
  setSsoProviderStatus: async (id: string, isActive: boolean, reason: string) =>
    (
      await apiClient.patch(`/governance-control/sso-providers/${id}/status`, {
        isActive,
        reason,
      })
    ).data,
};
